import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';


export default [
  {
    path: '/payments',
    name: 'PaymentsView',
    component: () => import(/* webpackChunkName: "payments" */ '@/modules/invoices/payments/PaymentsView'),
    meta: {
      moduleId: 'payments',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/project-accounting',
    name: 'ProjectAccountingOverview',
    component: () =>
      import(
        /* webpackChunkName: "project-accounting-overview" */ '@/modules/projects/components/project_accounting/components/ProjectAccountingOverview.vue'
      ),
    meta: {
      moduleId: 'project-accounting',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],  
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/project-accounting/:projectId',
    name: 'ProjectAccountingForm',
    component: () => import(/* webpackChunkName: "project-accounting-form" */ '@/modules/projects/components/project_accounting/components/ProjectAccountingForm.vue'),
    meta: {
      moduleId: 'project-accounting',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
  },
  {
    path: '/accountable-projects',
    name: 'ProjectHoursAccountingOverview',
    component: () =>
      import(
        /* webpackChunkName: "project-hours-accounting-overview" */ '@/modules/projects/components/project_accounting/components/ProjectHoursAccountingOverview.vue'
      ),
    meta: {
      moduleId: 'accountable-projects',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/accountable-projects/:id/accountable-consumptions/',
    name: 'AccountableProjectsForm',
    component: () => import(/* webpackChunkName: "accountable-projects-form" */ '@/modules/projects/components/project_accounting/components/AccountableProjectsForm.vue'),
    meta: {
      moduleId: 'accountable-projects',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
  },
];
